<section class="ene ds">
	<!-- Cabecera: contexto + CTA de alta (solo con permiso de gestión) -->
	<header class="ene-head">
		<span class="ene-head-ic"><mat-icon [inline]="true">bolt</mat-icon></span>
		<div class="ene-head-tx">
			<h3>{{ "energia.title" | translate }}</h3>
			<p>{{ "energia.subtitle" | translate }}</p>
		</div>
		<button type="button" class="btn btn-primary btn-sm" *ngIf="canManage" (click)="crear()">
			<mat-icon [inline]="true">add</mat-icon>
			{{ "energia.add" | translate }}
		</button>
	</header>

	<!-- Advertencia: centro ACTIVO sin ningún contrato de suministro en vigor -->
	<div class="ene-warn" *ngIf="sinSuministroVigente">
		<mat-icon [inline]="true">warning_amber</mat-icon>
		<p>{{ "energia.warnSinVigor" | translate }}</p>
	</div>

	<div class="ene-loading" *ngIf="loading">
		<mat-icon [inline]="true">hourglass_empty</mat-icon>
		<span>{{ "common.loading" | translate }}</span>
	</div>

	<app-empty-state
		*ngIf="!loading && cups.length === 0"
		icon="bolt"
		tone="neutral"
		[title]="'energia.empty.title' | translate"
		[message]="'energia.empty.message' | translate"
	></app-empty-state>

	<ng-container *ngIf="!loading && cups.length > 0">
		<!-- KPIs del centro -->
		<div class="ene-kpis">
			<div class="ene-kpi">
				<span class="ene-kpi-ic"><mat-icon [inline]="true">electrical_services</mat-icon></span>
				<div>
					<strong>{{ cups.length }}</strong>
					<small>{{ "energia.kpi.cups" | translate }}</small>
				</div>
			</div>
			<div class="ene-kpi">
				<span class="ene-kpi-ic"><mat-icon [inline]="true">bolt</mat-icon></span>
				<div>
					<strong>{{ formateaKwh(totalKwh) }}</strong>
					<small>{{ "energia.kpi.kwhAnio" | translate }}</small>
				</div>
			</div>
			<div class="ene-kpi">
				<span class="ene-kpi-ic"><mat-icon [inline]="true">speed</mat-icon></span>
				<div>
					<strong>{{ formateaKwh(totalPotenciaKw) }}</strong>
					<small>{{ "energia.kpi.potenciaKw" | translate }}</small>
				</div>
			</div>
			<div class="ene-kpi" *ngIf="proximoVencimiento">
				<span class="ene-kpi-ic"><mat-icon [inline]="true">event</mat-icon></span>
				<div>
					<strong>{{ proximoVencimiento | date: "dd/MM/yyyy" }}</strong>
					<small>{{ "energia.kpi.proximoFin" | translate }}</small>
				</div>
			</div>
		</div>

		<!-- Tabla de puntos de suministro -->
		<div class="ene-table-wrap">
			<table class="ene-table">
				<thead>
					<tr>
						<th>{{ "energia.col.punto" | translate }}</th>
						<th>{{ "energia.col.cups" | translate }}</th>
						<th>{{ "energia.col.estado" | translate }}</th>
						<th>{{ "energia.col.tarifa" | translate }}</th>
						<th>{{ "energia.col.lote" | translate }}</th>
						<th class="num">{{ "energia.col.kwhAnio" | translate }}</th>
						<th>{{ "energia.col.finContrato" | translate }}</th>
						<th *ngIf="canManage"></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let c of cups; trackBy: trackCups" [class.is-editable]="canManage" (click)="editar(c)">
						<td class="pt">{{ nombrePunto(c) }}</td>
						<td class="mono">{{ c.codigo }}</td>
						<td>
							<span class="ene-chip" [class.is-baja]="c.estado === 'BAJA'" *ngIf="c.estado">{{ c.estado }}</span>
							<span class="muted" *ngIf="!c.estado">—</span>
						</td>
						<td>{{ c.tarifa || "—" }}</td>
						<td>{{ c.lote || "—" }}</td>
						<td class="num">
							<ng-container *ngIf="c.consumoPrevistoKwhAnio != null">{{ formateaKwh(c.consumoPrevistoKwhAnio) }}</ng-container>
							<span class="ene-pend" *ngIf="c.consumoPrevistoKwhAnio == null" [matTooltip]="'energia.pendienteConsumo' | translate">
								<mat-icon [inline]="true">warning_amber</mat-icon>
							</span>
						</td>
						<td>
							<span class="ene-fecha">
								{{ c.fechaFinContrato ? (c.fechaFinContrato | date: "dd/MM/yyyy") : "—" }}
								<span
									class="ene-vencido"
									*ngIf="estaVencido(c)"
									[matTooltip]="'energia.vencidoTooltip' | translate"
									matTooltipPosition="right"
								><mat-icon [inline]="true">event_busy</mat-icon></span>
							</span>
						</td>
						<td class="acts" *ngIf="canManage" (click)="$event.stopPropagation()">
							<button type="button" class="ene-act" [matTooltip]="'common.edit' | translate" (click)="editar(c)">
								<mat-icon [inline]="true">edit</mat-icon>
							</button>
							<button type="button" class="ene-act is-danger" [matTooltip]="'common.delete' | translate" (click)="borrar(c)">
								<mat-icon [inline]="true">delete</mat-icon>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</ng-container>
</section>
